import { AppLocalStorage } from "../enums/appLocalStorage";
import { AppAddToICI } from "../enums/appAddToICI";
import { TEXT } from "../constants/texts";
const CryptoJS = require("crypto-js");

class SessionService {
  readonly appLocalStorage = AppLocalStorage;
  readonly sppAddToICIStorage = AppAddToICI;

  /**
   * Set user auth token
   */
  setAuthToken = (token) => {
    const allUserToken = CryptoJS.AES.encrypt(JSON.stringify(token), this.appLocalStorage.TOKEN).toString();
    return localStorage.setItem(this.appLocalStorage.TOKEN, allUserToken);
  };

  /**
   * Set read more token
   */
  setAddToICI = (readtoken) => {
    return localStorage.setItem(this.sppAddToICIStorage.ADDTOICI, readtoken);
  };

  setAuthCode = (authCode) => {
    return localStorage.setItem(TEXT.AUTH_CODE, authCode);
  };

  getAuthCode = () => {
    return localStorage.getItem(TEXT.AUTH_CODE);
  };

  /**
   * Get read more token
   */
  getAddToICI = () => {
    const userReadToken = localStorage.getItem(this.sppAddToICIStorage.ADDTOICI);
    return userReadToken;
  };
  /**
   * Get user auth token
   */
  getAuthToken = () => {
    if (localStorage.getItem(this.appLocalStorage.TOKEN) !== null) {
      const userTokenInfo = CryptoJS?.AES.decrypt(
        localStorage.getItem(this.appLocalStorage.TOKEN),
        this.appLocalStorage.TOKEN
      );
      const userToken = userTokenInfo.toString(CryptoJS.enc.Utf8);
      return userToken;
    } else {
      return null;
    }
  };

  /**
   * [Reset session of current logged in user.]
   */
  resetSession = () => {
    localStorage.clear();
    sessionStorage.clear();
  };

  setIdpAccessToken = (data) => {
    localStorage.setItem(TEXT.IDP_ACCESS_TOKEN, JSON.stringify(data));
  };
  getIdpAccessToken = () => {
    return JSON.parse(localStorage.getItem(TEXT.IDP_ACCESS_TOKEN));
  };

  setIdpRefreshToken = (data) => {
    localStorage.setItem(TEXT.IDP_REFRESH_TOKEN, JSON.stringify(data));
  };
  getIdpRefreshToken = () => {
    return JSON.parse(localStorage.getItem(TEXT.IDP_REFRESH_TOKEN));
  };

  setIdpIdToken = (data) => {
    localStorage.setItem(TEXT.IDP_ID_TOKEN, JSON.stringify(data));
  };
  getIdpIdToken = () => {
    return JSON.parse(localStorage.getItem(TEXT.IDP_ID_TOKEN));
  };

  setIdpExpiresIn = (data) => {
    localStorage.setItem(TEXT.IDP_EXPIRES_IN, JSON.stringify(data));
  };
  getIdpExpiresIn = () => {
    return JSON.parse(localStorage.getItem(TEXT.IDP_EXPIRES_IN));
  };

  setIcmExpiresIn = (data) => {
    localStorage.setItem(TEXT.ICM_EXPIRES_IN, JSON.stringify(data));
  };
  getIcmExpiresIn = () => {
    return JSON.parse(localStorage.getItem(TEXT.ICM_EXPIRES_IN));
  };

  setIcmRefreshToken = (data) => {
    localStorage.setItem(TEXT.ICM_REFRESH_TOKEN, JSON.stringify(data));
  };
  getIcmRefreshToken = () => {
    return JSON.parse(localStorage.getItem(TEXT.ICM_REFRESH_TOKEN));
  };
}

export default SessionService;
